import { useMemo } from "react";
import { conflitosDaConsulta } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

export type ConflitoDaConsulta = {
  /** Mesma sala no horário: sempre bloqueia (uma cadeira não atende duas pessoas). */
  sala: { nome: string; startTime: string; endTime: string } | null;
  /** Mesmo profissional no horário: avisa ou bloqueia, conforme a agenda. */
  dentista: boolean;
};

/**
 * O que bate com o horário proposto: a mesma sala ou o mesmo profissional. A regra é a mesma do
 * servidor (`conflitosDaConsulta`, em @bookdental/schemas) — as duas precisam concordar, senão a
 * tela avisa de conflito que o servidor aceita (ou o contrário).
 */
export function useAppointmentConflict({
  enabled,
  date,
  startTime,
  endTime,
  dentistId,
  salaId,
  editingId,
}: {
  enabled: boolean;
  date: string;
  startTime: string;
  endTime: string;
  dentistId?: string | null;
  salaId?: string | null;
  editingId?: string;
}): ConflitoDaConsulta {
  const query = trpc.appointment.listByRange.useQuery(
    {
      rangeStart: new Date(`${date}T00:00:00`),
      rangeEnd: new Date(`${date}T23:59:59`),
    },
    { enabled: enabled && !!date },
  );

  return useMemo(() => {
    if (!query.data || startTime >= endTime) return { sala: null, dentista: false };
    const c = conflitosDaConsulta({ id: editingId, startTime, endTime, dentistId, salaId }, query.data as any[]);
    return {
      sala: c.sala ? { nome: (c.sala as any).sala?.nome ?? "Essa sala", startTime: c.sala.startTime, endTime: c.sala.endTime } : null,
      dentista: !!c.dentista,
    };
  }, [query.data, startTime, endTime, dentistId, salaId, editingId]);
}
